import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { Carousel } from "react-bootstrap";
import "./booking.css";
import noImg from "../../assets/images/image_placeholder.jpg";

import DataView from "./DataView";
import moment from "moment";
import RoomFilterPopUp from "../roomBooking/RoomFilterPopUp";


import RoomBox from "./components/RoomBox";

import { getAllServiceList } from "../../API/serviceApi";
import { getAllEventList } from "../../API/eventApi";
import Spinner from "../../components/Spinner";
import BookingEngine from "../../components/BookingEngine";
import { getAllClassList } from "../../API/classApi";
import { getAllRoomList, getSelectRoomList } from "../../API/roomApi";
import { getFacilityRates } from "../../API/rateplanApi";
import { getPolicy } from "../../API/policyApi";
import { convertToISO } from "../../helper/Formatter";

export default function Bookings({ setLandingData, props , NavbarBgColor }) {
  const location = useLocation();
  const navigate = useNavigate();
  const companyName = localStorage.getItem("CompanyName");
  const loginAuth = localStorage.getItem("LoginAuth");
  const LoginUserId = localStorage.getItem("LoginUserId");
  const LoginUserType = localStorage.getItem("LoginUserType");
  const LoginBranchId = localStorage.getItem("branchid");

  let headerImg = [];

  if (
    setLandingData &&
    Array.isArray(setLandingData.headerimg) &&
    setLandingData.headerimg.length > 0
  ) {
    headerImg = setLandingData?.headerimg;
  } else if (setLandingData && setLandingData?.headerimg != null) {
    let obj = { attachment: setLandingData?.headerimg };
    headerImg?.push(obj);
  }

  const [selectedTab, setSelectedTab] = useState();
  const [activeTab, setActiveTab] = useState(null);
  const [serviceData, setServiceData] = useState();
  const [eventData, setEventData] = useState();
  const [isLoader, setLoader] = useState(false);
  const [classData, setClassData] = useState();
  const [pastEventData, setPastEventData] = useState([]);
  const [upcomingEventData, setUpcomingEventData] = useState([]);
  const [hideText, setHideText] = useState(false);
  const [allClassData, setAllClassData] = useState([]);
  const [roomData, setRoomData] = useState([]);
  const [apiRoomdata, setApiRoomData] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [tempFilterData, setTempFilterData] = useState([]);
  const [showFilterPopUp, ShowFilterPopup] = useState(false);
  const [bookedData, setBookedData] = useState({});
  const [storeCheckInOutDate, setStoreCheckInOutDate] = useState({});
  const [upcomingClass, setUpcomingClass] = useState([]);
  const [pastClass, setPastClass] = useState([]);
  const [serviceIds, setServiceIds] = useState([]);
  const [rateRoomData,setRateRoomData] = useState([])
  const [policyStoreData,setPolicyStoreData] = useState([])
  const [storeRoomData,setStoreRoomData] = useState(null)
  const [showDataFilter,setShowDataFilter] = useState(false)
  const [defaultData, setDefaultData] = useState({
    todayDate: new Date(),
    tomorrowDate: moment().add(1, "days"),
  });
  const [bookingPayload, setBookingPayloadDataa] = useState({});

     const getAllPolicy = async () => {
        return getPolicy();
      };

  useEffect(() => {
    const linkTo =
      setLandingData?.menu?.Rooms === "rooms"
        ? "rooms"
        : setLandingData?.menu?.Services === "service"
        ? "service"
        : setLandingData?.menu?.Events === "events"
        ? "events"
        : setLandingData?.menu?.Class === "class"
        ? "class"
        : null;

        setSelectedTab(linkTo);
        setActiveTab(linkTo);
      }, [setLandingData]);



useEffect(() => {
  const loadData = async () => {
    setLoader(true);
    try {
      const [allRoomRes,roomsFacilityRates,policyData] = await Promise.all([
        // fetchData(getServices),
        // fetchData(getEvent),
        // fetchData(getClass),
        fetchData(getAllRoom),
        fetchData(getRoomFacilityRates),
        fetchData(getAllPolicy)
        // fetchData(getRoomFacilityRates(storeDates?.todayDate, storeDates?.tomorrowDate)),
      ]);

      // localStorage.setItem("locale",allRoomRes?.[0]?.branchid?.locale)

      // handleServicesData(servicesRes);
      // handleEventData(eventRes);
      // handleClassData(classRes);
      // await handleRoomData(allRoomRes);
      handleRateRoomData(roomsFacilityRates);
      setPolicyStoreData(policyData?.[0]);
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoader(false);
    }
  };

  loadData();
}, []);




const fetchData = async (apiCall, ...params) => {
  try {
    const response = await apiCall(...params);
    if (response?.status === 200 && response != null) {
      return response?.data;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  return null;
};

const handleServicesData = (data) => {
  if (data) {
    setServiceData(data);
    setServiceIds(data?.map((item) => item?._id));
  }
};

const handleEventData = (data) => {
  if (data?.length > 0) {
    const pastEvents = data.filter((a) =>
      moment(a.property.startdate).isBefore(
        moment(new Date()).subtract(1, "days").format()
      )
    );
    const upcomingEvents = data.filter((a) =>
      moment(a.property.startdate).isAfter(
        moment(new Date()).subtract(1, "days").format()
      )
    );
    setPastEventData(pastEvents);
    setUpcomingEventData(upcomingEvents);
  }
};

const handleClassData = (data) => {
  if (data?.length > 0) {
    const pastClasses = data
      .filter((a) =>
        moment(a?.appointmentdate ? a?.appointmentdate : a?.bookingdate ).isBefore(
          moment(new Date()).subtract(1, "days").format()
        )
      )
      .sort((a, b) => moment(b?.appointmentdate ? b?.appointmentdate : b?.bookingdate).diff(moment(a?.appointmentdate ? a?.appointmentdate : a?.bookingdate)));
    const upcomingClasses = data.filter((a) =>
      moment(a?.appointmentdate ? a?.appointmentdate : a?.bookingdate).isAfter(
        moment(new Date()).subtract(1, "days").format()
      )
    );
    setPastClass(pastClasses);
    setUpcomingClass(upcomingClasses);
    setAllClassData(data);
  }
};

const handleRoomData = async (data) => {
  if (data?.length > 0) {
    try {
      const facilityRoomIds = data?.map((item) => item?._id).filter(Boolean);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const nextDay = new Date();
      nextDay.setDate(today.getDate() + 1);
      nextDay.setHours(0,0,0,0)

      const roomCheck = await getSelectedRoom(LoginBranchId, facilityRoomIds, today, nextDay);
      const checkIsAvailable = roomCheck?.filter((item) => item?.isAvailable)?.map((item) => item?._id);
      const uniqueData = [...new Set(checkIsAvailable)];
      const matchedArray = facilityRoomIds?.filter(id => uniqueData?.includes(id));
      const filteredData = data.filter(item => matchedArray.includes(item._id));
      setRoomData(filteredData);
    } catch (error) {
      console.error('error::: ', error);
    }
  }
};

const handleRateRoomData = (data) => {
  setRateRoomData(data);
  setApiRoomData(data);
}

// Usage for different API calls
const getSelectedRoom = async (branchId, facilityIds, checkInDate, checkOutDate) => {
  return await fetchData(getSelectRoomList, branchId, facilityIds, checkInDate, checkOutDate);
};

const getAllRoom = async () => {
  return getAllRoomList();
};

const getServices = async () => {
  return getAllServiceList();
};

const getEvent = async (date) => {
  return getAllEventList(date);
};

const getClass = async (date) => {
  return getAllClassList(date);
};

const getRoomFacilityRates = async (startDate, endDate) => {

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const a = startDate
  ? moment(startDate).startOf('day').toDate()
  : new Date();

  const b = endDate
  ? moment(endDate).startOf('day').toDate()
  : tomorrow

  return getFacilityRates(a, b);
}
const handleNavigation = (type, id) => {
  const companyName = localStorage.getItem("CompanyName");

  if (type === "Service" || type === "Event") {
    navigate(`/${companyName}/bookingview/${id}`, {
      state: { type: type.toLowerCase() },
    });
  } else {
    navigate(`/${companyName}/${type}detail/${id}`);
  }
};

  const handleRoomSubmit = async (checkInOutdata, event) => {
    event.preventDefault();
    setStoreCheckInOutDate(checkInOutdata);
    setShowDataFilter(false); // Always reset before fetching
    setStoreRoomData(null);

    try {
      setLoader(true);
      let res = await getRoomFacilityRates(checkInOutdata?.checkindate, checkInOutdata?.checkoutdate);
      handleRateRoomData(res?.data);
      setStoreRoomData(res?.data);
      setShowDataFilter(true); // Show after data is set
    } catch (error) {
      console.error("error::: ", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  function handleServiceSubmit(event, data) {
    event.preventDefault();
    if (data) {
      setHideText(true);
    }
  }

  async function handleEventSubmit(event, data) {
    event.preventDefault();
    if (data) {
      setHideText(true);
    }
    setLoader(true);
    var newDate = new Date(data);
    newDate.setHours(0, 0, 0, 0);
    const res = await getEvent(newDate);
    setLoader(false);
    setEventData(res?.data);
  }

  async function handleClassSubmit(event, data) {
    event.preventDefault();
    try {
      setLoader(true)
      if (data) {
        setHideText(true);
      }
      // setLoader(true);
      var newDate = new Date(data);
      newDate.setHours(0, 0, 0, 0);
      const res = await getClass(newDate);
      // setLoader(false);
      setClassData(res?.data);
    } catch (error) {
      setLoader(false)
      console.error('Error fetching class data:', error);
    }finally{
      setLoader(false)
    }
  }

  function handleClickTab(data) {
    setSelectedTab(data);
  }

  const handleServiceClick = (e) => {
    handleNavigation("Service", e?._id);
  };

  const handleSelectedEvents = (e) => {
    handleNavigation("Event", e?._id);
  };






  // const handlepostdata = async (value) => {
  //   //get old data for member push in waiting array
  //   let getolddata = await commonService.commonGetMethod(
  //     `groupclasses/`,
  //     value.attendee._id
  //   );
  //   console.log('getolddata::: ', getolddata);
  //   // return
  //   const groupClass = getolddata.data;
  //   let payload = {};
  //   payload.members = [];
  //   payload.members = groupClass.members;
  //   payload.members.push({
  //     memberid: LoginUserId,
  //     onModel: LoginUserType || "Member",
  //   });
  //   const availMembers = payload.members.map((a) => a.memberid?._id);
  //   if (payload.members.length >= +groupClass.property.bookingperson) {
  //     toast.warning("Class is fully occupied !");
  //     return null;
  //   } else if (availMembers.includes(localStorage.getItem("LoginUserId"))) {
  //     toast.warning("You already had been enrolled in this class. ");
  //     return null;
  //   }
  //   let res = await commonService.commonPATCHMethod(
  //     `groupclasses/${value.attendee._id}`,
  //     payload
  //   );
  //   return res;
  // };

  function handleOpenPopUp(item) {
    ShowFilterPopup(true);
    setSelectedItem(item);
  }

  function handleSelectedRoom(e,item) {
    if (loginAuth) {
      let id = e?._id;
      navigate(
        "/" +
          companyName +
          (location.pathname.split("/").includes("iframe") ? "/iframe" : "") +
          "/reviewroom",
        {
          state: {
            selectedData: e,
            roomInfo: bookedData,
            FilterRoomList: roomData,
            allRoomData: roomData,
          },
        }
      );
      ShowFilterPopup(true);
    } else {
      toast.error("Please login first");
    }
  }

  const handleClosePopup = (e) => {
    ShowFilterPopup(e);
  };

  let adultsum, childsum, extrabedsum;

  const handleSearchBookRoom = async (data, totalroomNo) => {
    var newCheckinDate = new Date(storeCheckInOutDate?.checkindate);
    var newCheckoutDate = new Date(storeCheckInOutDate?.checkindate);
    newCheckinDate.setHours(0, 0, 0, 0);
    newCheckoutDate.setHours(0, 0, 0, 0);
    let facilityids = roomData?.map((item) => item?._id);
    let checkInDate = newCheckinDate;
    let checkOutDate = newCheckoutDate;
    let branchId = LoginBranchId;

    try {
      setLoader(true)
      const response = await getSelectedRoom(
        branchId,
        facilityids,
        checkInDate,
        checkOutDate
      );
      let data = response.filter((item) => item?.isAvailable == true)?.map((item)=> item)
      // const checkIsAvailable = roomCheck?.filter((item) => item?.isAvailable)?.map((item) => item?._id);
      // const uniqueData = [...new Set(checkIsAvailable)];
      // const matchedArray = facilityRoomIds?.filter(id => uniqueData?.includes(id));
      // const filteredData = data.filter(item => matchedArray.includes(item._id));
      // setRoomData(filteredData);
      setRoomData(data);
    } catch (error) {
      setLoader(false)
      console.error("error::: ", error);
    }finally{
      setLoader(false)
    }

    setTempFilterData(data);
    adultsum = data.reduce(function (prev, current) {
      return prev + +current.Adult;
    }, 0);
    childsum = data.reduce(function (prev, current) {
      return prev + +current.Child;
    }, 0);
    extrabedsum = data.reduce(function (prev, current) {
      return prev + +current.ExtraBed;
    }, 0);

    ShowFilterPopup(false);
    // setLoader(true);

    setBookedData({
      checkindate: storeCheckInOutDate?.checkindate,
      checkoutdate: storeCheckInOutDate?.checkoutdate,
      adultsum: adultsum,
      extrabedsum: extrabedsum,
      childsum: childsum,
      totalroom: totalroomNo,
      rooms: data,
    });
  };

  const handleSearchBookRoom1 = async (data, totalroomNo) => {
    if (loginAuth) {
      try {
        adultsum = data.reduce(function (prev, current) {
          return prev + +current.Adult;
        }, 0);
        childsum = data.reduce(function (prev, current) {
          return prev + +current.Child;
        }, 0);
        extrabedsum = data.reduce(function (prev, current) {
          return prev + +current.ExtraBed;
        }, 0);
        ShowFilterPopup(false);
        let todayDate = moment(defaultData.todayDate?._d).format("YYYY-MM-DD");
        let tomorrowDate = moment(defaultData?.tomorrowDate?._d).format(
          "YYYY-MM-DD"
        );
        if (data?.length > selectedItem?.unitdetail?.length) {
          toast.error(
            "Room is not available",
            { autoClose: 1500 },
            { backgroundColor: "red" }
          );
        } else {
          navigate(
            "/" +
              companyName +
              (location.pathname.split("/").includes("iframe")
                ? "/iframe"
                : "") +
              "/reviewroom",
            {
              state: {
                selectedData: selectedItem,
                roomInfo: {
                  checkindate: todayDate,
                  checkoutdate: tomorrowDate,
                  adultsum: adultsum,
                  extrabedsum: extrabedsum,
                  childsum: childsum,
                  rooms: data,
                  totalroom: totalroomNo,
                },
                FilterRoomList: roomData,
                allRoomData: roomData,
              },
            }
          );
        }
      } catch (error) {}
      finally{
        setLoader(false)
      }
    } else {
      toast.error("Please login first");
    }
  };

  function handleViewDayWise() {
    navigate("/" + companyName + `/class`);
  }

  function passDataStoreRoomFun(data){
    setStoreRoomData(data);
    setRateRoomData(data);
    setShowDataFilter(true);
  }

  return (
    <div>
      <div className="carousel_container">
        {headerImg != null && headerImg !== undefined && (
          <Carousel>
            {headerImg?.map((item, index) => {
              return (
                <Carousel.Item key={index}>
                  <div className="carousel_img_container">
                    <img
                      style={{ width: "100%", height: "100%" }}
                      alt="carouselImg"
                      className="img-fluid"
                      src={item?.attachment ? item?.attachment : noImg}
                    />
                  </div>
                </Carousel.Item>
              );
            })}
          </Carousel>
        )}

        <div className="carousel_card_container">
          <BookingEngine
            setLandingData={setLandingData}
            ServiceSubmit={handleServiceSubmit}
            EventSubmit={handleEventSubmit}
            ClassSubmit={handleClassSubmit}
            RoomSubmit={handleRoomSubmit}
            ClickTab={handleClickTab}
            defaultValue={defaultData}
          />
        </div>
      </div>

      {isLoader && <Spinner />}

      <div className="data_body_container container">
        <h6 className="mt-4 text-capitalize">
          {(selectedTab === "rooms") &
          ( roomData?.length > 0 || rateRoomData?.length > 0)
            ? `Search result (${
              ( roomData?.length || 0 || rateRoomData?.length || 0)
              })`
            : (selectedTab === "events") & (eventData?.length > 0)
            ? `Search result (${eventData?.length || 0})`
            : (selectedTab === "service") & (serviceData?.length > 0)
            ? null
            : (selectedTab === "class") & (classData?.length > 0)
            ? `Search result (${classData?.length || 0})`
            : ""}
        </h6>

        {/* {selectedTab ? selectedTab : activeTab} */}

        <div className="tab_body_container">
          {/* selected room  */}
          {selectedTab === "rooms" && (
            <div className="row mt-3">

              <>
                {rateRoomData && rateRoomData.length !== 0 ? (
                  <RoomBox
                    policyStoreData={policyStoreData}
                    defaultDate={defaultData}
                    selectedDate={storeCheckInOutDate}
                    rateRoomData={rateRoomData}
                    passDataStoreRoomFun={passDataStoreRoomFun}
                    apiRoomdata={apiRoomdata}
                  />
                ) : (
                  <div className="col-12 text-center m-auto">
                    <img
                      width={400}
                      src="/images/no_found.svg"
                      className="img-fluid"
                      alt="no_found"
                    />
                    <p>We have no rooms available</p>
                  </div>
                )}
              </>

              {/* {roomData &&
                roomData?.length > 0 &&
                roomData?.map((item, index) => {
                  return (
                    <div className="col-3" key={index}>

                      <DataView
                       bookNowBtnName="Book now"
                        title={item?.title}
                        duration={false}
                        charge={item?.charges}
                        img={item?.profilepic}
                        availableRooms={true}
                        availableRoom={item?.unitdetail?.length}
                        onClick={() => {
                          if (storeCheckInOutDate?.checkindate) {
                            handleSelectedRoom(item);
                          } else {
                            handleOpenPopUp(item);
                          }
                        }}
                      />
                    </div>
                  );
                })}

              <>
                {hideText || !roomData || roomData?.length === 0 ? (
                  <div className="d-flex flex-column ml-3">
                    <h6 className="my-1 text-capitalize">
                      Search result ({roomData?.length})
                    </h6>
                    <p className="pt-2">
                      No results found. Please refine your search and try again.
                    </p>
                  </div>
                ) : null}
              </> */}
            </div>
          )}

          {/* All room */}

          {/* {allEventData?.length === 0 || allEventData === undefined ? (
                <p className="pl-3">No Data Found</p>
              ) : null}
            </>
          )}

          {/* All services */}

          {selectedTab === "service" && (
            <>
              <div className="row mt-3" />
              <h6 className="mt-3 text-capitalize">
                All Services ({serviceData?.length})
              </h6>
              <div className="row my-3">
                {serviceData?.map((item, index) => {
                  return (
                    <div className="col-3" key={index}>
                      <DataView
                        durationTime={true}
                        title={item?.title}
                        duration={item?.duration}
                        charge={item?.charges}
                        bookNowBtnName="Book now"
                        img={item?.gallery[0]?.attachment}
                        onClick={() => handleServiceClick(item)}
                      />
                    </div>
                  );
                })}
                {serviceData?.length === 0 || serviceData === undefined ? (
                  <p className="pl-3">No Data Found</p>
                ) : null}
              </div>
            </>
          )}

          {/* selected events */}
          {selectedTab === "events" && (
            <div className="row mt-3">
              {eventData &&
                eventData?.length > 0 &&
                eventData?.map((item, index) => (
                  <div className="col-3" key={index}>
                    <DataView
                      bookNowBtnName="Book now"
                      title={item?.title}
                      startTimeData={item?.property?.starttime}
                      startTime={true}
                      charge={item?.charges}
                      duration={item?.property?.starttime}
                      img={
                        item?.refid?.gallery[0]?.attachment ||
                        item?.property?.gallery[0]?.attachment
                      }
                      startDate={true}
                      addStartDate={moment(
                        item?.property?.startdate
                      ).format("DD/MM/YYYY")}
                      onClick={() => handleSelectedEvents(item)}
                    />
                  </div>
                ))}
              <>
                {eventData?.length === 0 && (
                  <div className="d-flex flex-column ml-3">
                    <h6 className="my-1 text-capitalize">
                      Search result ({eventData?.length})
                    </h6>
                    {/* <br /> */}
                    <p className="pt-2">
                      No results found. Please refine your search and try again.
                    </p>
                  </div>
                )}
              </>
            </div>
          )}

          {/* all events */}

          {selectedTab === "events" && (
            <>
              <h6 className="mt-3 text-capitalize">
                Upcoming events ({upcomingEventData?.length})
              </h6>

              <div className="row my-3">
                {upcomingEventData &&
                  upcomingEventData?.map((item, index) => {
                    return (
                      <div className="col-3" key={index}>
                        <DataView
                          title={item?.title}
                          startTimeData={item?.property?.starttime}
                          startTime={true}
                          duration={item?.property?.starttime}
                          charge={item?.charges}
                          img={
                            item?.refid?.gallery[0]?.attachment ||
                            item?.property?.gallery[0]?.attachment
                          }
                          startDate={true}
                          addStartDate={moment(
                            item?.property?.startdate
                          ).format("DD/MM/YYYY")}
                          bookNowBtnName="Book now"
                          onClick={() => handleSelectedEvents(item)}
                        />
                      </div>
                    );
                  })}
                {upcomingEventData &&
                (upcomingEventData?.length === 0 ||
                  upcomingEventData === undefined) ? (
                  <p className="pl-3">No Data Found</p>
                ) : null}
              </div>

              <h6 className="mt-3 text-capitalize">
                Past events ({pastEventData?.length})
              </h6>

              <div className="row my-3">
                {pastEventData &&
                  pastEventData?.map((item, index) => {
                    return (
                      <div className="col-3" key={index}>
                        <DataView
                          bookNowBtnName="Book now"
                          title={item?.title}
                          startTimeData={item?.property?.starttime}
                          startTime={true}
                          img={
                            item?.refid?.gallery[0]?.attachment ||
                            item?.property?.gallery[0]?.attachment
                          }
                          startDate={true}
                          displayBookingBtn={true}
                          addStartDate={moment(
                            item?.property?.startdate
                          ).format("DD/MM/YYYY")}
                          onClick={() => handleSelectedEvents(item)}
                        />
                      </div>
                    );
                  })}
                {pastEventData &&
                (pastEventData?.length === 0 || pastEventData === undefined) ? (
                  <p className="pl-3">No Data Found</p>
                ) : null}
              </div>
            </>
          )}

          {/*selected class */}


          {/* upcoming classData */}


        </div>

        {showFilterPopUp && (
          <RoomFilterPopUp
            showPopUp={handleClosePopup}
            searchroom={
              storeCheckInOutDate?.checkindate
                ? handleSearchBookRoom
                : handleSearchBookRoom1
            }
            filterdata={tempFilterData}
          />
        )}
      </div>
    </div>
  );
}
